import { post } from "@/utils/utils";
 
const shop = {
  state: {
    shopGoodsCategoryList: {}
  },
  mutations: {
    ADD_MICRO_SHOP_GOODS(state, data) {
      state.addshopGoodsCode = data.result;
    }
  },
  actions: {
    batchEditshopGoods({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/batch_edit`,
        name: "BATCH_EDIT_MICRO_SHOP_GOODS",
        params
      });
    }
  }
};

export default shop;
